<template>
    <v-menu
        offset-y
        :left="false"
        open-on-click
        allow-overflow
        z-index="1005"
        max-width="500px"
        class="icc-apps-menu"
        data-qa='icc-apps-menu'>
        <template v-slot:activator="{ on }">
            <v-btn
                id="icc-apps-menu-btn"
                class="cursor-pointer btn--icon-no-border ml-4"
                icon
                data-qa='icc-apps-menu-btn'
                v-on="on">
                <v-icon color='green darken-1'>apps</v-icon>
            </v-btn>
        </template>
        <v-flex
            class="icc-apps-menu-icons white"
            data-qa='icc-apps-menu-icons'>
            <v-container
                fluid
                grid-list-sm>
                <v-layout row>
                    <v-flex
                    text-xs-center
                    class="text-center">
                        <p
                            class="apps-title my-4 title font-weight-bold"
                            data-qa="apps-title">ICC Family of Solutions</p>
                    </v-flex>
                </v-layout>
                <v-layout
                    v-if="icons"
                    row
                    wrap>
                    <v-flex
                        v-for="(icon, index) in icons"
                        :key="index"
                        :data-qa="`apps-wrapper-${index}`"
                        xs4
                        text-xs-center>
                        <v-flex
                            flat
                            class="pa-2 white"
                            :data-qa="`apps-wrapper-click-${index}`"
                            @click="redirectUser(icon.link)">
                            <v-card-text
                                class="text-center cursor-pointer"
                            >
                                <img
                                    class="text-center"
                                    :data-qa="`apps-wrapper-img-${index}`"
                                    :src="icon.image"/>
                                <p
                                    class="mb-0 text-color-black text-center"
                                    :data-qa="`apps-wrapper-text-${index}`">{{ icon.text }}</p>
                            </v-card-text>
                        </v-flex>
                    </v-flex>
                    <v-flex
                    xs12
                    text-xs-center
                    @click="redirectUser(journal[0].link)">
                        <v-flex
                            flat
                            class="pa-2 white"
                            >
                            <v-card-text
                                class="text-center cursor-pointer"
                            >
                                <img
                                    class="text-center"
                                    :src="journal[0].image"/>
                                <p
                                    class="mb-0 text-color-black text-center">{{ journal[0].text }}</p>
                            </v-card-text>
                        </v-flex>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-flex>
    </v-menu>
</template>
<script>
import iccHome from '../../../assets/frontend/icons/menu_home.png'
import myICC from '../../../assets/frontend/icons/menu_my_icc.png'
import onLineCodes from '../../../assets/frontend/icons/menu_online_codes.png'
import cdpAccess from '../../../assets/frontend/icons/menu_cdp.png'
import menuStore from '../../../assets/frontend/icons/menu_store.png'
import menuSupport from '../../../assets/frontend/icons/menu_support.png'
import fosJournal from '../../../assets/frontend/icons/fos-journal.png'

export default {
  name: 'IccApps',
  data: function () {
    return {
      icons: [
        {
          image: iccHome,
          text: 'ICC Home',
          link: 'https://www.iccsafe.org/'
        },
        {
          image: myICC,
          text: 'myICC',
          link: 'https://my.iccsafe.org'
        },
        {
          image: onLineCodes,
          text: 'Digital Codes',
          link: 'https://codes.iccsafe.org'
        },
        {
          image: cdpAccess,
          text: 'cdpACCESS',
          link: 'http://www.cdpaccess.com'
        },
        {
          image: menuStore,
          text: 'Store',
          link: 'https://shop.iccsafe.org'
        },
        {
          image: menuSupport,
          text: 'Support',
          link: 'https://support.iccsafe.org'
        }
      ],
      journal: [{
        image: fosJournal,
        text: 'Journal',
        link: 'https://www.iccsafe.org/building-safety-journal/'
      }]
    }
  },
  methods: {
    /**
         * Redirect user
         */
    redirectUser (redirectUrl) {
      window.open(redirectUrl, '_blank')
    }
  }
}
</script>
